import { Route } from "react-router-dom";
import { SimpleErrorBoundary } from "~/components";
import { CreateOrganizationPage } from "./CreateOrganizationPage";
import {
  CreateOrganizationLoader,
  CreateOrganizationAction,
} from "./CreateOrganizationPage/loader";
import {
  OrganizationDetailsPage,
  OrganizationDetailsPageLoader,
  OrganizationDetailsPageAction,
  OrganizationRedirectLoader,
} from "./OrganizationDetailsPage";
import {
  OrgMemberDetailsPage,
  OrgMemberDetailsPageLoader,
  OrgMemberDetailsPageAction,
} from "./OrgMemberDetailsPage";
import {
  LifecycleAccessTabLoader,
  LifecycleAccessTabAction,
  InstanceAccessTabLoader,
  InstanceAccessTabAction,
} from "./OrgMemberDetailsPage/loaders";
import {
  LifecycleAccessTab,
  InstanceAccessTab,
} from "./OrgMemberDetailsPage/components";

export const OrganizationPagesRoutes = () => {
  return (
    <>
      <Route path="/organization" loader={OrganizationRedirectLoader} />
      <Route
        path="/organization/new"
        loader={CreateOrganizationLoader}
        action={CreateOrganizationAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<CreateOrganizationPage />}
      />
      <Route
        path="/organization/:organizationID"
        loader={OrganizationDetailsPageLoader}
        action={OrganizationDetailsPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<OrganizationDetailsPage />}
      />
      <Route
        path="/organization/:organizationID/member/:userID"
        loader={OrgMemberDetailsPageLoader}
        action={OrgMemberDetailsPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<OrgMemberDetailsPage />}
      >
        {/* Nested routes for tabs */}
        <Route index element={null} />
        <Route
          path="lifecycle-access"
          loader={LifecycleAccessTabLoader}
          action={LifecycleAccessTabAction}
          element={<LifecycleAccessTab />}
        />
        <Route
          path="instance-access"
          loader={InstanceAccessTabLoader}
          action={InstanceAccessTabAction}
          element={<InstanceAccessTab />}
        />
      </Route>
    </>
  );
};
